import EmptyLibrary from './EmptyLibrary';
export default EmptyLibrary;
